import axios from '../utils/axios';

export const listCustomers = async ({
  search,
  status,
  ownerUserId,
  limit = 50,
  page = 1,
  withStats = false,
  sortBy,
  sortDir,
} = {}) => {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status) params.set('status', status);
  if (ownerUserId) params.set('owner_user_id', ownerUserId);
  if (limit) params.set('limit', limit);
  if (page) params.set('page', page);
  if (withStats) params.set('with_stats', 'true');
  if (sortBy) params.set('sort_by', sortBy);
  if (sortDir) params.set('sort_dir', sortDir);
  const { data } = await axios.get(`/api/my-pages/customers?${params.toString()}`);
  return data;
};

// Admin-only: download an Excel (.xlsx) file of every client owned by a
// salesperson. Triggers a browser download and resolves once the file is saved.
export const exportSalespersonCustomers = async (ownerUserId) => {
  const params = new URLSearchParams();
  params.set('owner_user_id', ownerUserId);
  const response = await axios.get(
    `/api/my-pages/customers/export?${params.toString()}`,
    { responseType: 'blob' },
  );

  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `kunder-${ownerUserId}.xlsx`;

  const blob = new Blob([response.data], {
    type:
      response.headers['content-type']
      || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getCustomer = async (id) => {
  const { data } = await axios.get(`/api/my-pages/customers/${id}`);
  return data;
};

export const createCustomer = async (payload) => {
  const { data } = await axios.post('/api/my-pages/customers', payload);
  return data;
};

export const updateCustomer = async (id, payload) => {
  const { data } = await axios.put(`/api/my-pages/customers/${id}`, payload);
  return data;
};

export const updateCustomerOwner = async (id, ownerUserId) => {
  const { data } = await axios.put(`/api/my-pages/customers/${id}/owner`, {
    owner_user_id: ownerUserId,
  });
  return data;
};

export const getOwnerHistory = async (id) => {
  const { data } = await axios.get(`/api/my-pages/customers/${id}/owner-history`);
  return data;
};

export const getActivityLog = async (id, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  const qs = search.toString();
  const { data } = await axios.get(
    `/api/my-pages/customers/${id}/activity-log${qs ? `?${qs}` : ''}`,
  );
  return data;
};

export const mergeCustomers = async (id, mergeIntoId) => {
  const { data } = await axios.post(`/api/my-pages/customers/${id}/merge`, {
    merge_into_id: mergeIntoId,
  });
  return data;
};

// Manually connect a site (webbplats) to the customer. Used from the customer
// card's "Webbplatser & statistik" tab when the automatic CMS linking is
// misaligned.
export const linkSiteToCustomer = async (customerId, siteId) => {
  const { data } = await axios.post(`/api/my-pages/customers/${customerId}/sites`, {
    site_id: siteId,
  });
  return data;
};

// "Kundvy": ask the backend for a customer token so we can open this
// customer's Mina sidor as the customer sees it.
export const getImpersonationToken = async (id) => {
  const { data } = await axios.post(`/api/my-pages/customers/${id}/impersonation-token`);
  return data;
};

export const getBusinessClassification = async (id, { year } = {}) => {
  const qs = year ? `?year=${year}` : '';
  const { data } = await axios.get(
    `/api/my-pages/customers/${id}/business-classification${qs}`,
  );
  return data;
};
